import React, { useContext, useEffect, useState } from "react";
import { ChangeEvent } from "react";

import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

import { Snackbar, TextField, Typography } from "@mui/material";
import { TableBody, TableFooter, TableHead } from "@mui/material";
import { TableContainer, TableCell, TableRow } from "@mui/material";
import { Box, Paper, Stack } from "@mui/material";
import { TablePagination } from "@mui/material";

import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { del, get, post } from "../../../Services/tokenConfig";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { func_print } from "../../../Func_genericas/func_print";
import { OperacaoFertilizacaoExtra } from "./extraTabela";
import { ICabecalho5A, IPage5A, IPage5ADesdobramento } from "../../../Interfaces/cadernos/caderno5/interfaces5A";
import { operacaocultural_aux, operacoes } from "../../../informacao_estatica";
import Beneficiario_nome_id_alinhado_direita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { Alert } from "../../../Components/Alert/Alert";
import { desformatarNumero_return_null, formatarNumero_ao_digitar, desformatarNumero } from "../../../Func_genericas/formatar_numero_formato_pt";
import { formatar_numeros_Componentes_Quimicos } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/componentes_quimicos";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { CabecalhoForm } from "./cabecalho";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, message_apenas_numero } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { FilterByData } from "../../../Func_genericas/filter_by_data";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(0),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);

export default function RegOperFertil() {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;


  const [obj_anexo_cabecalho_selecionado, set_obj_anexo_cabecalho_selecionado] = useState<ICabecalho5A | undefined>();

  const [message, setMessage] = React.useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);


  const [openDelete, setOpenDelete] = React.useState<boolean>(false);
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(5);


  const [showNewRow, setShowNewRow] = useState<boolean>(false);

  const [error_data, set_error_data] = useState<boolean>(false);
  const [error_operacao, set_error_operacao] = useState<boolean>(false);
  const [error_fertilizante_utilizado, set_error_fertilizante_utilizado] = useState<boolean>(false);
  const [error_t, set_error_t] = useState<boolean>(false);
  const [error_m, set_error_m] = useState<boolean>(false);
  const [error_n, set_error_n] = useState<boolean>(false);
  const [error_po, set_error_po] = useState<boolean>(false);
  const [error_ko, set_error_ko] = useState<boolean>(false);
  const [error_mgo, set_error_mgo] = useState<boolean>(false);
  const [error_cao, set_error_cao] = useState<boolean>(false);
  const [error_so, set_error_so] = useState<boolean>(false);
  const [error_b, set_error_b] = useState<boolean>(false);

  const [rows, setRows] = useState<IPage5A[]>([]);
  const [rows_filtrada, setRows_filtrada] = useState<IPage5A[]>([]);

  const [newRow, setNewRow] = useState<IPage5A | undefined>();

  const [extraRows, setExtraRows] = useState<IPage5ADesdobramento[]>([]);
  const [extraRow, setExtraRow] = useState<IPage5ADesdobramento | undefined>();

  const camposNumericos = ["t", "m", "n", "po", "ko", "mgo", "cao", "so", "b"];

  const [flag_caderno_5_existe, set_flag_caderno_5_existe] = useState<boolean>(true);

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handleCancel()

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };


  /********************** GET FUNCTIONS *********************/
  async function getOperacoesFertil() {
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_operacoes_fertil_cabecalho/${obj_anexo_cabecalho_selecionado?.id_registo_fertil_cabecalho}`);
      if (res.status === 200) {

        const formattedData = res.data.result.map(formatar_numeros_Componentes_Quimicos);
        setRows(formattedData);
        setRows_filtrada(formattedData);

      };

      setIsLoading(false);
    } catch (error) {
      func_print("getOperacoesFertil", error, true);
      // setMessage("Erro ao efetuar a sua operação!");
      // setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      if (obj_anexo_cabecalho_selecionado !== undefined) {

        await getOperacoesFertil();
      } else {
        setIsLoading(false)
      }
    })();
  }, [obj_anexo_cabecalho_selecionado]);

  /**************** TABELA OPERAÇOES FERTIL **************************/
  // CREATE NEW ROW
  const onInputChange = (event: any) => {
    const { name, value, } = event.target;
    set_flag_editado(true)

    if (name === "data") {
      if (value === "" || value === undefined) {
        set_error_data(true);
      } else {
        set_error_data(false);
      }
    } else if (name === "operacao") {
      if (value === "" || value === undefined) {
        set_error_operacao(true);
      } else {
        set_error_operacao(false);
      }
    } else if (name === "fertilizante_utilizado") {
      if (value.trim() === "" || value === undefined) {
        set_error_fertilizante_utilizado(true);
      } else {
        set_error_fertilizante_utilizado(false);
      }
    }

    const isCampoNumerico = camposNumericos.includes(name);

    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {

        if (name === "t") {
          set_error_t(false);
        } else if (name === "m") {
          set_error_m(false);
        } else if (name === "n") {
          set_error_n(false);
        } else if (name === "po") {
          set_error_po(false);
        } else if (name === "k2o") {
          set_error_ko(false);
        } else if (name === "mgo") {
          set_error_mgo(false);
        } else if (name === "cao") {
          set_error_cao(false);
        } else if (name === "so") {
          set_error_so(false);
        } else if (name === "b") {
          set_error_b(false);
        }
      } else {
        if (name === "t") {
          set_error_t(true);
        } else if (name === "m") {
          set_error_m(true);
        } else if (name === "n") {
          set_error_n(true);
        } else if (name === "po") {
          set_error_po(true);
        } else if (name === "k2o") {
          set_error_ko(true);
        } else if (name === "mgo") {
          set_error_mgo(true);
        } else if (name === "cao") {
          set_error_cao(true);
        } else if (name === "so") {
          set_error_so(true);
        } else if (name === "b") {
          set_error_b(true);
        }
      }
      setNewRow((prevNewRows: any) => ({
        ...prevNewRows,
        [name]: formatarNumero_ao_digitar(valorSemFormatar)
      }));
    } else {
      setNewRow((prevNewRows: any) => ({
        ...prevNewRows,
        [name]: value,
      }));
    }

  };

  const handleSave = async () => {
    if (newRow?.data === undefined ||
      newRow.operacao === undefined ||
      newRow.fertilizante_utilizado === undefined || newRow.fertilizante_utilizado.trim() === ""
    ) {
      if (newRow?.data === undefined) {
        set_error_data(true);
      }
      if (newRow?.operacao === undefined) {
        set_error_operacao(true);
      }
      if (newRow?.fertilizante_utilizado === undefined || newRow?.fertilizante_utilizado.trim() === "") {
        set_error_fertilizante_utilizado(true);
      }

      setMessage("Preencha todos os campos obrigatórios!");
      setOpenSnackError(true);
    } else try {
      setIsLoading(true);
      let res = await post(auth.token.cookie_token, "new_reg_operacoes_fertil", {
        payload: {
          id_registo_fertil: 0,
          data: newRow?.data === undefined ? "" : newRow.data,
          operacao: newRow?.operacao === undefined ? "" : newRow.operacao,
          fertilizante_utilizado: newRow?.fertilizante_utilizado === undefined ? "" : newRow.fertilizante_utilizado,
          t: newRow?.t === undefined ? 0 : desformatarNumero(newRow.t),
          m: newRow?.m === undefined ? 0 : desformatarNumero(newRow.m),
          n: newRow?.n === undefined ? 0 : desformatarNumero(newRow.n),
          po: newRow?.po === undefined ? 0 : desformatarNumero(newRow.po),
          ko: newRow?.ko === undefined ? 0 : desformatarNumero(newRow.ko),
          mgo: newRow?.mgo === undefined ? 0 : desformatarNumero(newRow.mgo),
          cao: newRow?.cao === undefined ? 0 : desformatarNumero(newRow.cao),
          so: newRow?.so === undefined ? 0 : desformatarNumero(newRow.so),
          b: newRow?.b === undefined ? 0 : desformatarNumero(newRow.b),
          camp_opcao: newRow?.camp_opcao === undefined ? "" : newRow.camp_opcao,
          id_registo_fertil_cabecalho: obj_anexo_cabecalho_selecionado?.id_registo_fertil_cabecalho,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });
      if (res.status === 200) {
        setMessage("Gravado com sucesso!");

        setNewRow(undefined);
        setRows((prevRows) => {
          return [...prevRows, formatar_numeros_Componentes_Quimicos(res.data.result)]
        });
        setRows_filtrada((prevRows) => {
          return [...prevRows, formatar_numeros_Componentes_Quimicos(res.data.result)]
        });
        setOpenSnackSuccess(true);
        set_flag_editado(false)
        setShowNewRow(false);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleSave", error, true);
      if (error?.status === 409) {

        setMessage(error?.response.data.detail);
        setOpenSnackError(true);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    }
  };

  // Editar
  const handleEdit = (obj: IPage5A) => {
    handleCancel();
    setNewRow(obj);
  };

  const handleCancel = () => {
    setShowNewRow(false);
    setExtraRow(undefined);
    setNewRow(undefined)
    set_error_data(false);
    set_error_operacao(false);
    set_error_fertilizante_utilizado(false);
  }

  const onInputChange_editar = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    if (name === "data") {
      if (value === "" || value === undefined) {
        set_error_data(true);
      } else {
        set_error_data(false);
      }
    } else if (name === "operacao") {
      if (value === "" || value === undefined) {
        set_error_operacao(true);
      } else {
        set_error_operacao(false);
      }
    } else if (name === "fertilizante_utilizado") {
      if (value.trim() === "" || value === undefined) {
        set_error_fertilizante_utilizado(true);
      } else {
        set_error_fertilizante_utilizado(false);
      }
    }

    const isCampoNumerico = camposNumericos.includes(name);


    if (isCampoNumerico) {
      // Validação e formatação para campos numéricos para efetuar calculos
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(valorSemFormatar.replace(",", "."));

      if (!isNaN(valorNumerico)) {

        if (name === "t") {
          set_error_t(false);
        } else if (name === "m") {
          set_error_m(false);
        } else if (name === "n") {
          set_error_n(false);
        } else if (name === "po") {
          set_error_po(false);
        } else if (name === "k2o") {
          set_error_ko(false);
        } else if (name === "mgo") {
          set_error_mgo(false);
        } else if (name === "cao") {
          set_error_cao(false);
        } else if (name === "so") {
          set_error_so(false);
        } else if (name === "b") {
          set_error_b(false);
        }
      } else {
        if (name === "t") {
          set_error_t(true);
        } else if (name === "m") {
          set_error_m(true);
        } else if (name === "n") {
          set_error_n(true);
        } else if (name === "po") {
          set_error_po(true);
        } else if (name === "k2o") {
          set_error_ko(true);
        } else if (name === "mgo") {
          set_error_mgo(true);
        } else if (name === "cao") {
          set_error_cao(true);
        } else if (name === "so") {
          set_error_so(true);
        } else if (name === "b") {
          set_error_b(true);
        }
      }
      setNewRow((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: formatarNumero_ao_digitar(valorSemFormatar),
      }));
    } else {
      setNewRow((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    };
  };

  const handleUpdate = async () => {

    if (newRow?.data === undefined ||
      newRow?.operacao === undefined ||
      newRow?.fertilizante_utilizado === undefined || newRow?.fertilizante_utilizado.trim() === ""
    ) {
      if (newRow?.data === undefined) {
        set_error_data(true);
      }
      if (newRow?.operacao === undefined) {
        set_error_operacao(true);
      }
      if (newRow?.fertilizante_utilizado === undefined || newRow?.fertilizante_utilizado.trim() === "") {
        set_error_fertilizante_utilizado(true);
      }
      setMessage("Preencha todos os campos obrigatórios!");
      setOpenSnackError(true);
    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "update_reg_operacoes_fertil", {
          payload: {
            id_registo_fertil: newRow?.id_registo_fertil,
            data: newRow?.data === undefined ? null : newRow.data,
            operacao: newRow?.operacao === undefined ? null : newRow.operacao,
            fertilizante_utilizado: newRow?.fertilizante_utilizado === undefined ? "" : newRow.fertilizante_utilizado,
            t: newRow?.t === undefined ? 0 : desformatarNumero_return_null(newRow.t),
            m: newRow?.m === undefined ? 0 : desformatarNumero_return_null(newRow.m),
            n: newRow?.n === undefined ? 0 : desformatarNumero_return_null(newRow.n),
            po: newRow?.po === undefined ? 0 : desformatarNumero_return_null(newRow.po),
            ko: newRow?.ko === undefined ? 0 : desformatarNumero_return_null(newRow.ko),
            mgo: newRow?.mgo === undefined ? 0 : desformatarNumero_return_null(newRow.mgo),
            cao: newRow?.cao === undefined ? 0 : desformatarNumero_return_null(newRow.cao),
            so: newRow?.so === undefined ? 0 : desformatarNumero_return_null(newRow.so),
            b: newRow?.b === undefined ? 0 : desformatarNumero_return_null(newRow.b),
            camp_opcao: newRow?.camp_opcao === undefined ? "" : newRow.camp_opcao,
            id_registo_fertil_cabecalho: obj_anexo_cabecalho_selecionado?.id_registo_fertil_cabecalho,
            last_update: newRow?.last_update,
            create_date: newRow?.create_date,
            uuid: newRow?.uuid,
          }
        });

        if (res.status === 200) {
          setMessage("Registado com sucesso!");
          const updatedRows = rows.map((row) => {
            if (row.id_registo_fertil === newRow.id_registo_fertil) {
              return formatar_numeros_Componentes_Quimicos(res.data.result)
            } else {
              return { ...row }
            }
          });
          set_flag_editado(false)

          setRows(updatedRows !== undefined ? updatedRows : []);
          setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
          setNewRow(undefined);
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error: any) {
        func_print("handleUpdate", error, true);
        if (error?.status === 409) {

          setMessage(error?.response.data.detail);
          setOpenSnackError(true);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }

        setIsLoading(false);
      }
    }

  }
  // Delete
  const handleClickOpenDelete = (obj: IPage5A) => {
    setNewRow(obj);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_operacoes_fertil/${newRow?.id_registo_fertil}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDelete(false);
        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_fertil !== newRow?.id_registo_fertil),
        ]);
        setRows_filtrada((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_fertil !== newRow?.id_registo_fertil),
        ]);
        setNewRow(undefined);

        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  /*****************  PAGINAÇÃO ********************** */
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <CustomThemeProvider>
      <div className={classes.root}>
        <CadernoLayout title="5A - Registo de Operações de Fertilização" />
        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <Box width="80%" margin="auto">
            <Beneficiario_nome_id_alinhado_direita />
          </Box>
          <FilterByData
              listas={[
                {
                  lista_original: rows,
                  set_lista_filtrada: setRows_filtrada,
                  campoData: "data",
                },
               
              ]}
            />
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {

            flag_caderno_5_existe === true ?
              <div style={{
                background: cores.cor5,
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: 'center',
                alignSelf: 'center',
                justifySelf: 'center',
                width: '98%',
                borderRadius: 3,
                height: 60,
                fontWeight: 'bold',
                marginTop: 10,
                marginBottom: 10,
              }}>
                <div style={{
                  paddingRight: 30,
                  paddingLeft: 30,
                }}>
                  <WarningAmberRoundedIcon />
                </div>
                O Caderno 5 - Registo de Operações Culturais está preenchido, sendo assim não necessário preencher este caderno.
                <div style={{
                  paddingRight: 30,
                  paddingLeft: 30,
                }}>
                  <WarningAmberRoundedIcon />
                </div>
              </div>
              : <></>
          }


          <Box style={{ width: "100%", height: "auto" }}>
            <CabecalhoForm
              obj_anexo_cabecalho_selecionado={obj_anexo_cabecalho_selecionado}
              set_obj_anexo_cabecalho_selecionado={set_obj_anexo_cabecalho_selecionado}
              set_flag_caderno_5_existe={set_flag_caderno_5_existe}
            />
          </Box>

          {isLoading ? (
            <LoadingVulpes />
          ) : (
            obj_anexo_cabecalho_selecionado !== undefined ?

              <TableContainer
                component={Paper}
                sx={{
                  height: "auto", width: "auto", margin: 2, padding: 2,
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                  {is_historico === true ? <></> :

                    <BarraDeFerramentas
                      mostrarBotaoNovo
                      textoBotaoNovo="Nova linha"
                      aoClicarNovo={() => {
                        handleCancel();
                        setShowNewRow(true)
                      }}
                    />}
                </Box>
                <table style={{ width: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <StyledTableHead rowSpan={2}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Data*
                          <BasicPopover text={" O registo das operações deverá seguir a ordem cronológica da sua ocorrência.No caso das fertirregas,\n o seu registo poderá estar agrupado por períodos mensais; quinzenais; semanais, ou outros.\n\nFormato para registo diário deverá ser: dd-mm-aaaa"} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Operação*
                          <BasicPopover text={"O beneficiário deverá preencher com um dos seguintes valores por linha (data da aplicação):\nAplicação de corretivos\nFertilização fundo\nAdubação verde\nAplicação de estrume\nAplicação de chorume\nFertilização cobertura\nFertirrigação\n\nNo caso de compromisso ativo na intervenção «Uso Eficiente da Água», o beneficiário deverá preencher  \ncom as operações de fertilização previstas no Plano de Fertilização (Anexo 1) quando realizadas."} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Fertilizante utilizado*
                          <BasicPopover text={"No caso de adução verde identificar as espécies integradas no solo."} />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead colSpan={2}> Quantidade Aplicada </StyledTableHead>
                      <StyledTableHead colSpan={8}>Incorporação de nutrientes (Kg) </StyledTableHead>
                      <StyledTableHead rowSpan={2}>Ações</StyledTableHead>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead sx={{ minWidth: 80 }}>t</StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 80 }}>m3</StyledTableHead>
                      <StyledTableHead>N</StyledTableHead>
                      <StyledTableHead>P2O5</StyledTableHead>
                      <StyledTableHead>K2O</StyledTableHead>
                      <StyledTableHead>MgO</StyledTableHead>
                      <StyledTableHead>CaO</StyledTableHead>
                      <StyledTableHead>SO3</StyledTableHead>
                      <StyledTableHead>B</StyledTableHead>
                      <StyledTableHead>
                        Outros
                        <BasicPopover text={"Identificar o nutriente aplicado, quando este não esteja representado no registo"} />
                      </StyledTableHead>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showNewRow && (
                      <TableRow>
                        <StyledTableCell>
                          <TextField
                            variant="filled"
                            name="data"
                            type="date"
                            value={newRow?.data !== undefined ? newRow.data : ""}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => onInputChange(e)}
                          />
                          {error_data && (
                            <p style={{ color: "#c90606", fontSize: "11px" }}>
                              Preencha este campo
                            </p>
                          )}
                        </StyledTableCell>
                        <StyledTableCell>
                          {/* <CustomSelect
                            value={newRow?.operacao !== undefined ? newRow.operacao : ""}
                            name="operacao"
                            onChange={onInputChange}
                            options={operacoes}
                            label="Operação"
                            minWidth={120}

                          /> */}
                          <CreatableSelect
                            formatCreateLabel={(inputValue) => `Criar "${inputValue}"`}

                            placeholder={'Selecionar'}
                            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                            noOptionsMessage={() => "Não encontrado"}
                            menuPosition="absolute"
                            menuShouldScrollIntoView={false}
                            styles={{
                              menuPortal: base => ({
                                ...base,
                                fontSize: 14
                              }),

                              option: (styles, state) => ({
                                ...styles,
                                color: state.isSelected ? 'white' : 'black',
                                fontSize: 14,
                                backgroundColor: state.isSelected ? cores.cor1 : 'white',
                                '&:hover': {
                                  backgroundColor: cores.cor3,
                                  color: 'white',
                                }

                              }),

                              control: base => ({
                                ...base,
                                fontSize: 14,

                                height: 50,
                                minHeight: 10,
                                width: 200,
                                alignItems: 'center',
                                paddingTop: 0,
                                marginTop: 0,
                                boxShadow: 'none',
                                border: `1px solid silver`,
                                '&:hover': {
                                  border: '1px solid silver',
                                }
                              }),

                              input: (provided, state) => ({
                                ...provided,
                                fontSize: 14,
                                paddingTop: 0,
                                marginTop: 0,

                              }),

                            }}
                            onChange={(e: any) => {
                              if (e.label === e.value) {
                                setNewRow((prevnewRow: any) => ({
                                  ...prevnewRow,
                                  ['operacao']: e.label,
                                }));

                              } else {

                                setNewRow((prevnewRow: any) => ({
                                  ...prevnewRow,
                                  ['operacao']: e.label,
                                }));

                              }
                            }}
                            options={operacaocultural_aux}
                          />
                          {error_operacao && (
                            <p style={{ color: "#c90606", fontSize: "11px" }}>
                              Preencha este campo
                            </p>
                          )}
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="fertilizante_utilizado"
                            value={newRow?.fertilizante_utilizado}
                            onChange={onInputChange}
                            error={error_fertilizante_utilizado}
                            helperText={error_fertilizante_utilizado ? "Preencha este campo" : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="t"
                            value={newRow?.t}
                            onChange={onInputChange}
                            error={error_t}
                            helperText={error_t ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="m"
                            value={newRow?.m}
                            onChange={onInputChange}
                            error={error_m}
                            helperText={error_m ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="n"
                            value={newRow?.n}
                            onChange={onInputChange}
                            error={error_n}
                            helperText={error_n ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="po"
                            value={newRow?.po}
                            onChange={onInputChange}
                            error={error_po}
                            helperText={error_po ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="ko"
                            value={newRow?.ko}
                            onChange={onInputChange}
                            error={error_ko}
                            helperText={error_ko ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="mgo"
                            value={newRow?.mgo}
                            onChange={onInputChange}
                            error={error_mgo}
                            helperText={error_mgo ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="cao"
                            value={newRow?.cao}
                            onChange={onInputChange}
                            error={error_cao}
                            helperText={error_cao ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="so"
                            value={newRow?.so}
                            onChange={onInputChange}
                            error={error_so}
                            helperText={error_so ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="b"
                            value={newRow?.b}
                            onChange={onInputChange}
                            error={error_b}
                            helperText={error_b ? message_apenas_numero : ""}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <CustomTextField
                            name="camp_opcao"
                            value={newRow?.camp_opcao}
                            onChange={onInputChange}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          <Stack direction="row" justifyContent="center">
                            <ButtonCadernos
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {
                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  handleCancel()
                                }
                              }}
                              mostrarBotaoGravar
                              aoClicarGravar={() => handleSave()}
                            />
                          </Stack>
                        </StyledTableCell>
                      </TableRow>
                    )}
                    {(rowsPerPage > 0
                      ? rows_filtrada.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : rows_filtrada
                    ).map((row, index) => (
                      <TableRow key={index}>
                        {newRow?.id_registo_fertil === row.id_registo_fertil ? (
                          <>
                            <StyledTableCell>
                              <TextField
                                variant="filled"
                                name="data"
                                type="date"

                                value={newRow?.data}
                                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                  onInputChange_editar(e)
                                }
                              />
                              {error_data && (
                                <p style={{ color: "#c90606", fontSize: "11px" }}>
                                  Preencha este campo
                                </p>
                              )}
                            </StyledTableCell>
                            <StyledTableCell>
                              {/* <CustomSelect
                                value={newRow?.operacao}
                                name="operacao"
                                onChange={onInputChange_editar}
                                options={operacoes}
                                label="Operação"
                                minWidth={120}
                              /> */}

                              <CreatableSelect
                                formatCreateLabel={(inputValue) => `Criar "${inputValue}"`}

                                placeholder={'Selecionar'}
                                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                noOptionsMessage={() => "Não encontrado"}
                                menuPosition="absolute"
                                menuShouldScrollIntoView={false}
                                styles={{
                                  menuPortal: base => ({
                                    ...base,
                                    fontSize: 14
                                  }),

                                  option: (styles, state) => ({
                                    ...styles,
                                    color: state.isSelected ? 'white' : 'black',
                                    fontSize: 14,
                                    backgroundColor: state.isSelected ? cores.cor1 : 'white',
                                    '&:hover': {
                                      backgroundColor: cores.cor3,
                                      color: 'white',
                                    }

                                  }),

                                  control: base => ({
                                    ...base,
                                    fontSize: 14,

                                    height: 50,
                                    minHeight: 10,
                                    width: 200,
                                    alignItems: 'center',
                                    paddingTop: 0,
                                    marginTop: 0,
                                    boxShadow: 'none',
                                    border: `1px solid silver`,
                                    '&:hover': {
                                      border: '1px solid silver',
                                    }
                                  }),

                                  input: (provided, state) => ({
                                    ...provided,
                                    fontSize: 14,
                                    paddingTop: 0,
                                    marginTop: 0,

                                  }),

                                }}
                                onChange={(e: any) => {
                                  if (e.label === e.value) {
                                    setNewRow((prevnewRow: any) => ({
                                      ...prevnewRow,
                                      ['operacao']: e.label,
                                    }));

                                  } else {

                                    setNewRow((prevnewRow: any) => ({
                                      ...prevnewRow,
                                      ['operacao']: e.label,
                                    }));

                                  }
                                }}
                                options={operacaocultural_aux}
                              />
                              {error_operacao && (
                                <p style={{ color: "#c90606", fontSize: "11px" }}>
                                  Preencha este campo
                                </p>
                              )}
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="fertilizante_utilizado"
                                value={newRow?.fertilizante_utilizado}
                                onChange={onInputChange_editar}
                                error={error_fertilizante_utilizado}
                                helperText={error_fertilizante_utilizado ? "Preencha este campo" : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="t"
                                value={newRow?.t}
                                onChange={onInputChange_editar}
                                error={error_t}
                                helperText={error_t ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="m"
                                value={newRow?.m}
                                onChange={onInputChange_editar}
                                error={error_m}
                                helperText={error_m ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="n"
                                value={newRow?.n}
                                onChange={onInputChange_editar}
                                error={error_n}
                                helperText={error_n ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="po"
                                value={newRow?.po}
                                onChange={onInputChange_editar}
                                error={error_po}
                                helperText={error_po ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="ko"
                                value={newRow?.ko}
                                onChange={onInputChange_editar}
                                error={error_ko}
                                helperText={error_ko ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="mgo"
                                value={newRow?.mgo}
                                onChange={onInputChange_editar}
                                error={error_mgo}
                                helperText={error_mgo ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="cao"
                                value={newRow?.cao}
                                onChange={onInputChange_editar}
                                error={error_cao}
                                helperText={error_cao ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="so"
                                value={newRow?.so}
                                onChange={onInputChange_editar}
                                error={error_so}
                                helperText={error_so ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="b"
                                value={newRow?.b}
                                onChange={onInputChange_editar}
                                error={error_b}
                                helperText={error_b ? message_apenas_numero : ""}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <CustomTextField
                                name="camp_opcao"
                                value={newRow?.camp_opcao}
                                onChange={onInputChange_editar}
                              />
                            </StyledTableCell>
                          </>
                        ) : (
                          <>
                            <StyledTableCell>{row.data}</StyledTableCell>
                            <StyledTableCell>{row.operacao}</StyledTableCell>
                            <StyledTableCell>{row.fertilizante_utilizado} </StyledTableCell>
                            <StyledTableCell>{row.t}</StyledTableCell>
                            <StyledTableCell>{row.m}</StyledTableCell>
                            <StyledTableCell>{row.n}</StyledTableCell>
                            <StyledTableCell>{row.po}</StyledTableCell>
                            <StyledTableCell>{row.ko}</StyledTableCell>
                            <StyledTableCell>{row.mgo}</StyledTableCell>
                            <StyledTableCell>{row.cao}</StyledTableCell>
                            <StyledTableCell>{row.so}</StyledTableCell>
                            <StyledTableCell>{row.b}</StyledTableCell>
                            <StyledTableCell>{row.camp_opcao} </StyledTableCell>
                          </>
                        )}
                        {newRow?.id_registo_fertil === row.id_registo_fertil ? (
                          <StyledTableCell>
                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() => handleUpdate()}
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {
                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  handleCancel()
                                }
                              }}
                            />
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell>
                            {is_historico === true ? <></> :

                              <ButtonCadernos
                                mostrarBotaoEditar
                                aoClicarEditar={() =>
                                  handleEdit(row)
                                }
                                mostrarBotaoApagar
                                aoClicarApagar={() => handleClickOpenDelete(row)}
                              />}
                          </StyledTableCell>
                        )}
                      </TableRow>
                    ))}
                    <OperacaoFertilizacaoExtra
                      extraRows={extraRows}
                      extraRow={extraRow}
                      setExtraRow={setExtraRow}
                      setExtraRows={setExtraRows}
                      idCabecalho={obj_anexo_cabecalho_selecionado?.id_registo_fertil_cabecalho}
                      setOpenSnackError={setOpenSnackError}
                      setOpenSnackSuccess={setOpenSnackSuccess}
                      setIsLoading={setIsLoading}
                      setMessage={setMessage}
                    />
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={12} />
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow sx={{ width: "100%" }}>
                      <TableCell colSpan={6}>
                        <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                          * Campos de preenchimento obrigatório
                        </Typography>
                      </TableCell>
                      <TablePagination
                        rowsPerPageOptions={[
                          5,
                          10,
                          25,
                          { label: "All", value: -1 },
                        ]}
                        colSpan={8}
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        labelDisplayedRows={({ from, to, count }) => {
                          return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                        }}
                        labelRowsPerPage={'Linhas por página'}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </table>
              </TableContainer>
              :
              <></>
          )}
          <ConfirmDialog
            open={openDelete}
            onClose={() => setOpenDelete(false)}
            onConfirm={handleDelete}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />

        </main>
      </div>
    </CustomThemeProvider>
  );
}
